module.exports = __webpack_public_path__ + "static/img/pic3.8370c37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case4/pic3.jpg
// module id = B/0z
// module chunks = 1